// extracted by mini-css-extract-plugin
export default {"join":"CorporateGifts_join__EfClc","joinDesc":"CorporateGifts_joinDesc__y93kc","contactUs":"CorporateGifts_contactUs__u+Dyg"};